<script lang="ts">
  // "English · Tagalog · Bisaya", each name in its own language, no flags. Sits above every screen.
  import { GUEST_LOCALES, t, type Locale } from '../lib/i18n'

  let { lang, onPick }: { lang: Locale; onPick: (l: Locale) => void } = $props()
</script>

<nav class="g-lang" aria-label={t('common.changeLanguage')}>
  {#each GUEST_LOCALES as l, i (l.code)}
    {#if i > 0}<span aria-hidden="true">·</span>{/if}
    <button type="button" lang={l.code} aria-pressed={lang === l.code} onclick={() => onPick(l.code)}>{l.label}</button>
  {/each}
</nav>
